import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Icon,
  Text,
  VStack,
  HStack,
  useColorModeValue,
} from '@chakra-ui/react'
import { Flame, AlertTriangle } from 'lucide-react'

interface BurnConfirmModalProps {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
}

export function BurnConfirmModal({ isOpen, onConfirm, onCancel }: BurnConfirmModalProps) {
  const iconBg = useColorModeValue('orange.50', 'orange.900')

  return (
    <Modal isOpen={isOpen} onClose={onCancel} isCentered size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader textAlign="center" pb={0}>
          <VStack spacing={3}>
            <HStack
              w={14}
              h={14}
              bg={iconBg}
              borderRadius="full"
              align="center"
              justify="center"
            >
              <Icon as={Flame} boxSize={7} color="orange.500" />
            </HStack>
            <Text fontFamily="heading">Burn After Read</Text>
          </VStack>
        </ModalHeader>
        <ModalBody>
          <VStack spacing={3} textAlign="center">
            <Text color={useColorModeValue('stone.600', 'stone.300')} fontSize="sm">
              This share is set to <strong>burn after reading</strong>. Once you
              open it, the content will be permanently deleted and cannot be
              accessed again by anyone.
            </Text>
            <HStack
              spacing={2}
              bg={useColorModeValue('orange.50', 'orange.900')}
              px={3}
              py={2}
              borderRadius="md"
              w="full"
              justify="center"
            >
              <Icon as={AlertTriangle} boxSize={4} color="orange.500" />
              <Text fontSize="sm" color={useColorModeValue('orange.700', 'orange.300')} fontWeight="medium">
                Make sure you are ready to view it now.
              </Text>
            </HStack>
          </VStack>
        </ModalBody>
        <ModalFooter gap={3}>
          <Button variant="ghost" onClick={onCancel} flex={1}>
            Not now
          </Button>
          <Button colorScheme="orange" onClick={onConfirm} flex={1}>
            Open &amp; burn
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
